import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import React, { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PlanChangesLogDialogContent } from './components/planChangesLogDialogContent/PlanChangesLogDialogContent'

interface IPlanChangesLogDialogProps {
  partnerId: string
  programType: ProgramTypes
  fYear: number
  changeDate?: string
  isDistributor: boolean
  onClose: () => void
  isOpen: boolean
}

export const PlanChangesLogDialog = ({
  isOpen,
  partnerId,
  programType,
  fYear,
  changeDate,
  isDistributor,
  onClose,
}: IPlanChangesLogDialogProps) => {
  const contentProps = useMemo(() => {
    return {
      partnerId,
      programType,
      fYear,
      changeDate,
      isDistributor,
      onClose,
    }
  }, [partnerId, programType, fYear, changeDate, isDistributor, onClose])

  return (
    <ModalDialog
      show={isOpen}
      size={'auto'}
      onClose={onClose}
      content={PlanChangesLogDialogContent}
      contentProps={contentProps}
    />
  )
}
